export function stringToPrice(value: string) {
  return Number(parseFloat(value).toFixed(2));
}
